import { ChevronLeft, ChevronRight } from "lucide-react";

export const HEADLINE_EMOJIS = ["🔥", "🐎", "⭐", "🤠", "💥", "🏆", "💎", "🌟", "🚀", "✨", "❤️", "🥇", "🐴", "⚡", "🎯", "👑", "none"];

export function EmojiCarousel({ value, onChange, disabled, required, error }) {
  const idx = HEADLINE_EMOJIS.indexOf(value);
  const n = HEADLINE_EMOJIS.length;
  const step = (d) => onChange(HEADLINE_EMOJIS[idx < 0 ? (d > 0 ? 0 : n - 1) : (idx + d + n) % n]);
  const btn = "h-12 w-12 sm:h-11 sm:w-11 shrink-0 rounded-full border border-stone-300 bg-white text-stone-700 flex items-center justify-center transition-colors duration-150 hover:border-amber-700 hover:text-amber-800 active:bg-amber-50 disabled:opacity-40 disabled:pointer-events-none";
  return (
    <div data-testid="headline-emoji-carousel" id="field-horse-headline_emoji" tabIndex={-1} className="mt-2 outline-none">
      <span className="block text-[11px] uppercase tracking-wider text-stone-400 font-semibold mb-1.5">Headline Emoji{required && <span data-testid="headline-emoji-required" className="text-red-600"> *</span>}</span>
      <div className="flex items-center gap-4">
        <button type="button" aria-label="Previous emoji" data-testid="headline-emoji-prev" disabled={disabled} onClick={() => step(-1)} className={btn}>
          <ChevronLeft className="h-5 w-5" />
        </button>
        <div data-testid="headline-emoji-current" aria-live="polite" className="min-w-[96px] text-center select-none">
          {value === "none" ? <span className="text-sm font-medium text-stone-500">No Emojis</span>
            : idx >= 0 ? <span className="text-3xl leading-none">{value}</span>
            : <span data-testid="headline-emoji-unset" className="text-sm font-medium text-stone-500">Choose…</span>}
        </div>
        <button type="button" aria-label="Next emoji" data-testid="headline-emoji-next" disabled={disabled} onClick={() => step(1)} className={btn}>
          <ChevronRight className="h-5 w-5" />
        </button>
      </div>
      {error && <p data-testid="headline-emoji-error" className="mt-1 text-xs text-red-600">Please select a headline emoji</p>}
    </div>
  );
}
